<div class="navigation flex justify-start items-center content-center" vexContainer>
  <vex-navigation-item *ngFor="let item of items" [item]="item"></vex-navigation-item>
</div>
